export const APP_DOWNLOAD_URL_KEY = 'appDownloadUrl';

export interface AppDownloadUrlValue {
  buyerAppQrCodeUrl: string;
  sellerAppQrCodeUrl: string;
  buyerAppUniversalLink: string;
  buyerAppAndroidLink: string;
  sellerAppUniversalLink: string;
  sellerAppAndroidLink: string;
}

export const emptyAppDownloadUrl = (): AppDownloadUrlValue => ({
  buyerAppQrCodeUrl: '',
  sellerAppQrCodeUrl: '',
  buyerAppUniversalLink: '',
  buyerAppAndroidLink: '',
  sellerAppUniversalLink: '',
  sellerAppAndroidLink: '',
});

const readSideUrl = (parsed: Record<string, unknown>, role: 'buyer' | 'seller'): string => {
  if (role === 'buyer') {
    if (typeof parsed.buyerAppQrCodeUrl === 'string') {
      return parsed.buyerAppQrCodeUrl;
    }
    if (typeof parsed.buyer === 'string') {
      return parsed.buyer;
    }
    return '';
  }
  if (typeof parsed.sellerAppQrCodeUrl === 'string') {
    return parsed.sellerAppQrCodeUrl;
  }
  if (typeof parsed.seller === 'string') {
    return parsed.seller;
  }
  return '';
};

export const parseAppDownloadUrl = (raw: string | undefined): AppDownloadUrlValue => {
  if (!raw?.trim()) {
    return emptyAppDownloadUrl();
  }
  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const readLink = (key: string): string =>
      typeof parsed[key] === 'string' ? (parsed[key] as string) : '';

    return {
      buyerAppQrCodeUrl: readSideUrl(parsed, 'buyer'),
      sellerAppQrCodeUrl: readSideUrl(parsed, 'seller'),
      buyerAppUniversalLink: readLink('buyerAppUniversalLink'),
      buyerAppAndroidLink: readLink('buyerAppAndroidLink'),
      sellerAppUniversalLink: readLink('sellerAppUniversalLink'),
      sellerAppAndroidLink: readLink('sellerAppAndroidLink'),
    };
  } catch {
    return emptyAppDownloadUrl();
  }
};

export const readAppDownloadUrl = (
  configs: Map<string, string>,
  role: 'buyer' | 'seller'
): string => {
  const parsed = parseAppDownloadUrl(configs.get(APP_DOWNLOAD_URL_KEY));
  const url = role === 'buyer' ? parsed.buyerAppQrCodeUrl : parsed.sellerAppQrCodeUrl;
  return url.trim();
};

export const readAppOpenBaseLink = (
  configs: Map<string, string>,
  role: 'buyer' | 'seller',
  os: 'ios' | 'android' | 'other'
): string => {
  const parsed = parseAppDownloadUrl(configs.get(APP_DOWNLOAD_URL_KEY));
  const useAndroid = os === 'android';
  if (role === 'buyer') {
    const link = useAndroid ? parsed.buyerAppAndroidLink : parsed.buyerAppUniversalLink;
    return link.trim();
  }
  const link = useAndroid ? parsed.sellerAppAndroidLink : parsed.sellerAppUniversalLink;
  return link.trim();
};
